export const removeWhitespace = (v: string): string =>
  (v || "").replace(/\s/g, "");
